import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import { trackEvent, EventNames } from '../../lib/analytics';

const baseStyles = ['absolute', 'f3', 'z-3', 'dn', 'db-l'];
const buttonStyles = ['bn', 'bg-transparent', 'outline-0', 'pa0', 'white', 'pointer'];

const VideoRepositionControls = ({ fcId, isRepositioned, onClick, player, videoId }) => {
  return (
    <div
      className={`video-reposition-controls ${cx(baseStyles)}`}
      style={{ right: '57px', bottom: '8px' }}
    >
      <button
        type="button"
        className={cx(buttonStyles, { dn: isRepositioned, dib: !isRepositioned })}
        data-id="video-detached-button"
        onClick={() => {
          onClick(true);
        }}
      >
        <i className="icon-video-detached" />
      </button>
      <button
        type="button"
        className={cx(buttonStyles, { dib: isRepositioned, dn: !isRepositioned })}
        data-id="video-splitscreen-button"
        onClick={() => {
          onClick(false);
        }}
      >
        <i className="icon-video-splitscreen" />
      </button>
    </div>
  );
};

VideoRepositionControls.propTypes = {
  fcId: PropTypes.string,
  isRepositioned: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  player: PropTypes.shape({}),
  videoId: PropTypes.string,
};

VideoRepositionControls.defaultProps = {
  fcId: null,
  player: null,
  videoId: null,
};

export default VideoRepositionControls;
